/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.resource', []);